import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { editItem } from "../redux/cartListSlice";
import QuantitySelector from "./QuantitySelector";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./cartItem.css";
import "../assets/ReactToastify.css";

export default function CartItem({ data, onItemRemove }) {
  const dispatch = useDispatch();
  const [insufficientStock, setInsufficientStock] = React.useState(false);

  const stockVerification = async (slug) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/stock/${slug}`
      );
      console.log(response.data);
      const stock = response.data;
      return stock;
    } catch (err) {
      console.log(err.data);
    }
  };

  const handleQuantityInc = async () => {
    if (data.quantity + 1 <= data.stock) {
      dispatch(editItem({ slug: data.slug, quantity: data.quantity + 1 }));
      setInsufficientStock(false);
      // toast.success("Product added to cart", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
    } else {
      setInsufficientStock(true);
    }
  };

  const handleQuantityDec = () => {
    if (data.quantity - 1 >= 1) {
      dispatch(editItem({ slug: data.slug, quantity: data.quantity - 1 }));
      setInsufficientStock(false);
      // toast.success("Product removed to cart", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
    }
  };

  return (
    <div
      className="container border-bottom justify-content-between d-flex p-0 m-0 mb-2"
      style={{ backgroundColor: "white" }}
    >
      <div className="d-flex">
        <div
          className="p-0 m-0"
          style={{
            height: "9rem",
            width: "9rem",
            maxWidth: "9rem",
            minWidth: "9rem",
            overflow: "hidden",
          }}
        >
          <img
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            // src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/laderhack/products/${data.img}`}
            src={`../img/ProductImg2/${data.img}`}
            alt={data.slug}
            className="p-0 m-0"
          />
        </div>
        <div className="p-0 pt-3 m-0 mb-3 d-flex flex-column align-items-start">
          <Link
            style={{ textDecoration: "none" }}
            to={"/product/" + data.slug}
            className="p-0 m-0 fs-4 text-decoration-none text-dark text-start fw-light"
          >
            {data.name}
          </Link>
          <p className="p-0 m-0 fs-6 d-inline-flex justify-content-center align-items-center">
            Quantity:
            <QuantitySelector
              val={data.quantity}
              onDec={handleQuantityDec}
              onInc={handleQuantityInc}
            />
          </p>
          {insufficientStock && (
            <p>Insufficient stock. Please check again in 2-3 business days.</p>
          )}
          <p className="p-0 m-0 mt-2 fs-4">${data.price}</p>
        </div>
      </div>
      <div className="p-0 pt-3 m-0 d-flex flex-column align-items-end justify-content-between">
        <button className="btn  mb-3 lh-1" onClick={onItemRemove}>
          <i id="trash-icon" className="bi bi-trash"></i>
        </button>
      </div>
    </div>
  );
}
